export default __webpack_public_path__ + "static/media/93.be7e67bb.png";